var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_c('a',{staticClass:"circle-btn circle-btn--variant_2",attrs:{"href":_vm.$options.url}},[_c('span',{staticClass:"circle-btn__icon circle-btn__icon--color_1 icon-like"})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }